import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

import { store } from '@/store';
import { queryClient } from '@/common/config/queryClient.ts';
import { ThemeProvider } from './components/ThemeProvider';
import App from './App';
import { initLogger } from '@/services/logger';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import '@/i18n/i18n';

initLogger();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <App />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
          />
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);